import { useMutation } from 'react-query'
import { useNavigate, useParams } from 'react-router-dom'

import { joinRelRoute } from 'src/common/utils'
import { ROUTES } from 'src/constants'

import AuthDataService from 'src/services/auth.service'

const useForgotPasswordVerify = () => {
  const { token } = useParams()
  const navigate = useNavigate()

  return useMutation((code: string) => AuthDataService.verifyResetPassword(token!, code), {
    onSettled: (data) => {
      if (!data) return

      if (!data.agreement && data.registrationToken) {
        return navigate(
          joinRelRoute(
            ROUTES.REGISTER_FINISH,
            `${data.registrationToken}?email=${data.email}${data.agreement_with_account ? '' : '&without_account=true'
            }&with_password=true`,
          ),
        )
      }

      navigate(`/reset-password/${token}`)
    },
  })
}

export { useForgotPasswordVerify }
